export default "__VITE_ASSET__CTiz6L6A__"